<template>
    <v-snackbar
        v-model="snack"
        :timeout="time"
        rounded="pill"
        :right="right"
        :app="app"
        :dark="$vuetify.theme.dark"
        :min-width="maxWidth ? '90%' : null"
        :max-width="maxWidth"
        class="glass-snackbar"
        @input="clear"
    >
        {{ text }}

        <template v-slot:action="{ attrs }">
            <v-btn
                :color="error ? 'error' : 'primary'"
                text
                v-bind="attrs"
                @click="clear(0)"
            >
                Close
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    name: "SoliSnack",
    data: function () {
        return {
            snack: true, //this.text ? true : false
        };
    },
    props: {
        text: {
            type: String,
        },
        time: {
            type: Number,
            default: 6000,
        },
        error: {
            type: Boolean,
            default: false,
        },
        right: {
            type: Boolean,
            default: false,
        },
        app: {
            type: Boolean,
            default: true,
        },
        maxWidth: {
            type: [Number, String],
            default: null,
        },
    },
    methods: {
        clear(delay = 500) {
            setTimeout(() => {
                this.$page.props.successMessage = null;
                this.$emit("hide");
                this.snack = false;
            }, delay);
        },
    },
};
</script>
